import React from 'react';
import { JoraEmployerHelmet } from '@common/components/Helmet';
import { useTranslation } from '@common/hooks/useTranslation';
import { PageHeader } from '@components/PageHeader';

export interface CajaWrapperProps {
  children: React.ReactNode;
  title?: string;
}

export default function CajaWrapper(props: CajaWrapperProps) {
  const { title } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      {title && (
        <div>
          <JoraEmployerHelmet title={t(title)} />
          <PageHeader>{t(title)}</PageHeader>
        </div>
      )}

      <div z-index={1}>{props.children}</div>
    </div>
  );
}
